import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Notification16 } from '@hig/icons';
import Modal from '@hig/modal';
import RadioButton from '@hig/radio-button';
import Button from '@hig/button';
import Spacer from '@hig/spacer';
import Label from  '@hig/label';
import Input from '@hig/input';
import Checkbox from '@hig/checkbox';
import {
    createUserCustomThreshold,
    deleteUserThreshold,
    getUserThreshold,
    updateUserThreshold,
} from '../../utils/cloud-credit-api-methods';

import './styles.scss';

const modalStyles = (styles) => {
    delete styles.modal.window.left;
    return {
        modal: {
            ...styles.modal,
            header: {
                ...styles.modal.header,
                backgroundColor: '#f5f5f5',
                fontSize: '16px',
                height: '50px',
                minHeight: '50px',
                borderBottom: 'none'
            },
            headerContent: {
                ...styles.modal.headerContent,
                "& > button": {
                    height: "16px",
                    width: "16px",
                    position: "absolute",
                    left: "268.46px",
                    top: "17px",
                    borderRadius: "4px",
                    color: "#808080"
                }
            },
            overlay: {
                ...styles.modal.overlay,
                position: "relative",
                backgroundColor: 'transparent',
                zIndex: 1,
            },
            window: {
                ...styles.modal.window,
                position: 'absolute',
                top: '-50px',
                right: '-160px',
                width: '307px',
                height: '298px',
                zIndex: 1,
            }
        },
    };
};

const labelStylesSheet = (styles) => {
    return {
        ...styles,
        label: {
            ...styles.label,
            fontFamily: "Artifakt Element, sans-serif",
            marginBottom: '0px'
        }
    };
};

const inputStylesSheet = (styles) => {
    return {
        ...styles,
        input: {
            ...styles.input,
            fontFamily: "Artifakt Element, sans-serif"
        }
    };
};

const paragraphStyles = {
    lineHeight: '1.4',
    fontSize: '14px'
};
// TODO: DEVX-8354 GracePeriod logic, we do not know user's balance
const CloudCreditWidget = ({ customThreshold, defaultThreshold, oxygenId, token, plan }) => {
    const [openModal, setOpenModal] = useState(false);
    const [isDefault, setIsDefault] = useState(true);
    const [isCustom, setIsCustom] = useState(false);
    const [customValue, setCustomValue] = useState(null);
    const [disableButton, setDisableButton ] = useState(true);
    const [checkBox, setCheckBox] = useState(false);
    const [initRender, setInitRender] = useState(true);

    let userThreshold = customThreshold;
    // Not all defaultThreshold values will be 0.
    const minVal = Number.parseFloat(defaultThreshold.value, 10) === 0 ? 1 : 0;

    useEffect(() => {
        if(userThreshold.length) {
            const { value } = userThreshold[0];
            setIsCustom(true);
            setIsDefault(false);
            setCustomValue(value);
        } else {
            setIsCustom(false);
        }
    }, []);

    useEffect(() => {
        setDisableButton(handleDisableButton());
    }, [isCustom, isDefault, customValue]);

    const modalButtonClickHandler = () => {
        setOpenModal(!openModal);
    };

    const radioButtonOnChangeHandler = () => {
        setIsDefault(!isDefault);
        setIsCustom(!isCustom);
        setInitRender(false);
    };

    const handleDisableButton = () => {
        if (isCustom && customValue) {
            return false;
        } else if (isDefault) {
            return false;
        } else {
            return true;
        }

    };

    const customValueOnChangeHandler = (e) => {
        if(e.target.validity.valid) {
            setCustomValue(e.target.valueAsNumber);
        }
    };

    const onCustomInputHandler = (e) => {

        if(e.target.validity.valid) {
            setCustomValue(e.target.valueAsNumber);
        } else {
            e.target.value = customValue;
        }

    };

    const checkboxClickHandler = () => {
        setCheckBox(!checkBox);
    };

    const saveCustomValue = async (e) => {
        e.preventDefault();
        let isCustomValSet = false;
        let isDefaultSet = false;

        if (isCustom && parseInt(customValue)) {
            if (userThreshold.length) {
                isCustomValSet = await updateUserThreshold(token, oxygenId, customValue, plan);
            } else {
                isCustomValSet = await createUserCustomThreshold(token, oxygenId, customValue, plan);
            }
            userThreshold = await getUserThreshold(token, oxygenId);
        } else if(isDefault && userThreshold.length) {
            isDefaultSet = await deleteUserThreshold(token, oxygenId);
            setCustomValue("");
        }
        setOpenModal(false);
        setDisableButton(true);
    };

    return (
      <>
        <button
            id="cloud-credit-widget-btn"
            onClick={modalButtonClickHandler}
        >
            <Notification16 color="#0696d7" />
        </button>
        <Modal
            open={openModal}
            onCloseClick={modalButtonClickHandler}
            title={
                <span id="modal-title">
                    <Notification16 color="#0696d7" />
                    <span id="modal-header-text">&nbsp;&nbsp;Manage alerts</span>
                </span>
            }
            stylesheet={modalStyles}
        >
            <div>
                <form>
                    <div>
                        <p style={paragraphStyles}>Notify me when my balance reaches</p>
                    </div>
                    <div className="cc-form-radio-container">
                        <RadioButton
                            defaultChecked={!userThreshold.length}
                            name="cloud-credits"
                            id="cloud-credits-default"
                            value={isDefault}
                            onChange={radioButtonOnChangeHandler}
                        />
                        <Spacer spacing="s" />
                        <Label htmlFor="cloud-credits-default" stylesheet={labelStylesSheet}>{defaultThreshold.value} Tokens</Label>
                    </div>
                    <div className="cc-form-radio-container">
                        <RadioButton
                            defaultChecked={userThreshold.length}
                            name="cloud-credits"
                            id="cloud-credits-custom-value"
                            value={isCustom}
                            onChange={radioButtonOnChangeHandler}
                        />
                        <Spacer spacing="s" />
                        <Input
                            type="number"
                            min={minVal}
                            max="10000"
                            placeholder="Set Value"
                            value={customValue}
                            variant="line"
                            onChange={customValueOnChangeHandler}
                            onInput={onCustomInputHandler}
                            stylesheet={inputStylesSheet}
                        />
                    </div>
                    <div className="cc-form-checkbox-container">
                        <Checkbox
                            defaultChecked={checkBox}
                            id="check-email"
                            onClick={checkboxClickHandler}
                        />
                        <Spacer spacing="s" />
                        <Label htmlFor="check-email" stylesheet={labelStylesSheet}>Do not send me email alerts</Label>
                    </div>
                    <div className="cc-form-submit-btn">
                        <Button
                            onClick={saveCustomValue}
                            title="Save"
                            type="primary"
                            disabled={initRender|| disableButton}
                        />
                    </div>
                </form>
            </div>
        </Modal>
      </>
    );
};

CloudCreditWidget.propTypes = {
    customThreshold: PropTypes.arrayOf(PropTypes.object),
    defaultThreshold: PropTypes.object,
    oxygenId: PropTypes.string,
    token: PropTypes.string,
    plan: PropTypes.string
};

export default CloudCreditWidget;